import React from 'react';
import "./Banner.scss"

import playButton from "../../Assets/images/play-button.svg";
import bannerImage from "../../Assets/images/home-banner.jpg";


const Banner = () => (
  <main>
    <section className="main-wraper banner-cvr">
      <img className="bg-image" src={bannerImage} alt="Background" />
      <div className="transperant-wraper" id="transperantDiv"></div>
      <div className='banner-main-content'>
        <div className="container">
          <div className="banner-content">
            <div className="row align-wraper sp-width">
              <div className="col-md-6">
                <div className="banner-inner">
                  <h1>Lorem Ipsum is Simply <br />Dummy Text of the</h1>
                  <h2>Printing & Typestting Industry</h2>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                    Lorem Ipsum has been the industries
                  </p>
                  <a className="banner-btn1" href="#">Get Details</a>
                  <a className="banner-btn2 banner-play" href="#"><img className="play-button" src={playButton} alt="Play" /> Watch Demo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default Banner;
